import { render, staticRenderFns } from "./QueueDropdown.vue?vue&type=template&id=55ce8ab2&"
import script from "./QueueDropdown.vue?vue&type=script&lang=js&"
export * from "./QueueDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports